/**
 *
 * @param {!Object<Function>} functions
 * @param {!Function} callback
 */
export function parallel (functions, callback) {
  var hasReturned = false;
  var response = {};

  // validate the functions
  if (!functions) {
    throw new Error('utils/parallel first parameter must be a valid object of functions');
  }

  // validate the callback parameter
  if (typeof callback !== 'function') {
    throw new Error('utils/parallel second parameter must be a valid callback function');
  }

  // validate the keys
  var keys = Object.keys(functions);
  if (!keys.length) {
    throw new Error('utils/parallel functions parameter must have at least one key');
  }

  // validate the functions
  keys.forEach((key) => {
    if (typeof functions[key] !== 'function') {
      throw new Error(`utils/parallel functions.${key} must be a valid function`);
    }
  });

  /**
   * Generates a callback function with the scope of the "key"
   * @param {String} key
   * @returns {Function}
   */
  var asyncResponse = function (key) {

    /**
     * callback passed to the functions
     * @param {Error|null} err
     * @param {*} data
     */
    return function (err, data) {
      if (hasReturned) {
        // ignore this callback if we already returned
        return;
      }

      // first error, we return an error
      if (err) {
        hasReturned = true;
        return callback(err);
      }

      // check if the callback for this key was already called
      if (response[key]) {
        return console.error(`utils/parallel callback for the key ${key} has been called more than once!`);
      }

      // here it's a success
      response[key] = data;

      // if all async calls returned, return a success
      if (Object.keys(response).length === keys.length) {
        hasReturned = true;
        return callback(null, response);
      }
    };
  };

  // execute all functions now
  keys.forEach(key => functions[key](asyncResponse(key)));
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/utils/async.js